import type { ReactNode } from 'react'

interface StickyFormFooterProps {
    /**
     * Nút của footer (thường là "Hủy" + "Lưu"). Ở mobile các button sẽ
     * stretch full-width qua flex-1 nếu caller set; caller nên dùng
     * `flex-1 md:flex-none` để tận dụng.
     */
    children: ReactNode
    /**
     * Class bổ sung (vd `md:justify-end` mặc định là đúng, override khi cần).
     */
    className?: string
}

/**
 * Footer cho form dài có 2-3 button submit/cancel.
 * - Mobile (< 768px): fixed bottom, border-t, bg full width — user luôn
 *   thấy button dù scroll đâu. Caller nên thêm `pb-24 md:pb-0` cho container
 *   form để content không bị footer đè.
 * - Tablet + Desktop (≥ 768px): static, right-aligned, no border — pattern
 *   cổ điển.
 */
export function StickyFormFooter({
    children,
    className,
}: StickyFormFooterProps) {
    return (
        <div
            data-testid="sticky-form-footer"
            className={`fixed inset-x-0 bottom-0 z-20 flex gap-2 border-t bg-background p-3 md:static md:mt-4 md:justify-end md:border-0 md:p-0 ${className ?? ''}`}
        >
            {children}
        </div>
    )
}
